<template>
  <div class="advertiser-page">
    <!-- 1. Hero Section -->
    <section class="hero-section">
      <div class="container hero-container">
        <div class="hero-text">
          <h1>Drive high-quality leads across GlobalAI Team</h1>
          <p>
            We are a big media-buyer team and have 15 around fully in-house
            media-buyers who have been engaging in LeadGen business more than
            4-5 years, especially in Home-services, Nutra, Sweepstakes.
          </p>
          <div class="hero-buttons">
            <button class="btn btn-primary" @click="openContactForm">
              Contact Us
            </button>
            <!-- <button class="btn btn-secondary" @click="openLoginForm">{{ translator('adv_hero_btn2') }}</button> -->
          </div>
        </div>
        <div class="hero-image">
          <!-- 请将图片路径替换为您的实际路径 -->
          <img
            src="../../static/images/advertiser/hero-illustration.png"
            alt="Ad Networks"
          />
        </div>
      </div>
    </section>

    <!-- 2. Why Global AI Section -->
    <section class="why-section">
      <div class="container why-container">
        <div class="why-image">
          <!-- 请将图片路径替换为您的实际路径 -->
          <img
            src="../../static/images/advertiser/why-ai-illustration.png"
            alt="Why Global AI"
          />
        </div>
        <div class="why-text">
          <h2>Why Global AI?</h2>
          <ul class="why-list">
            <li>
              Our team has over 5 years of experience in Lead Generation
              business, with extensive expertise in advertising strategies,
              creative materials, landing page development, and data
              accumulation;
            </li>
            <li>
              A professional design and technical team are in place to provide
              specialized support.
            </li>
            <li>
              A professional design and technical team is in place to provide
              specialized advertising support.
            </li>
            <li>
              Supports integration with third-party tracking systems such as
              Clickflare and Voluum.
            </li>
            <li>
              Efficient collaboration and responsiveness in communication.
            </li>
          </ul>
        </div>
      </div>
    </section>

    <!-- 3. Features Section -->
    <section class="features-section">
      <div class="container">
        <h2>Drive High-quality Leads with GlobalAI</h2>
        <div class="features-grid">
          <div class="feature-item">
            <img
              src="../../static/images/advertiser/feature-icon-1.png"
              alt="Diverse Ecosystem Icon"
            />
            <h3>Variety of traffic types</h3>
            <ul class="feature-list">
              <li>Social Traffic Source</li>
              <li>Native Traffic Source</li>
              <li>Push &amp; Email traffic Source</li>
              <li>Other traffic types that are allowed by feed providers</li>
            </ul>
          </div>
          <div class="feature-item">
            <img
              src="../../static/images/advertiser/feature-icon-2.png"
              alt="Campaign Management Icon"
            />
            <h3>Fast increase &amp; scale-up spend</h3>
            <p>
              Our team ensures seamless alignment with advertisers on-boarding
              processes. Once ROAS turns positive, we will rapidly scale up
              campaigns to maximize spend and profit.
            </p>
          </div>
          <div class="feature-item">
            <img
              src="../../static/images/advertiser/feature-icon-3.png"
              alt="Transparency Icon"
            />
            <h3>High- quality &amp; Quick made of Pre-lander Pages</h3>
            <p>
              With strong technical support, we rapidly build and test landing
              pages tailored to product categories, optimize based on
              performance data, and stay closely aligned with clients to drive
              fast, positive results.
            </p>
          </div>
          <div class="feature-item">
            <img
              src="../../static/images/advertiser/feature-icon-4.png"
              alt="Prompt Response Icon"
            />
            <h3>Fast increase &amp; scale-up spend</h3>
            <p>
              Our team works closely with advertisers to ensure a smooth
              integration into their established workflows. Upon reaching a
              positive ROAS return on ad spend, we swiftly initiate strategic
              expansion of the campaigns to optimize both advertising investment
              and profitability.
            </p>
          </div>
        </div>
      </div>
    </section>

    <!-- Partners Section -->
    <section class="partners-section">
      <div class="container">
        <h2>Our Partners</h2>
        <div class="partners-grid">
          <div class="partner-logo">
            <img
              src="../../static/images/Partners/clickbank.png"
              alt="ClickBank"
            />
          </div>
          <div class="partner-logo">
            <img
              src="../../static/images/Partners/clickdealer.png"
              alt="ClickDealer"
            />
          </div>
          <div class="partner-logo">
            <img src="../../static/images/Partners/drcash.png" alt="DRCash" />
          </div>
          <div class="partner-logo">
            <img src="../../static/images/Partners/moxxi.png" alt="Moxxi" />
          </div>
          <div class="partner-logo">
            <img
              src="../../static/images/Partners/nutraleads.png"
              alt="NutraLeads"
            />
          </div>
          <div class="partner-logo">
            <img
              src="../../static/images/Partners/Point2web.png"
              alt="Point2Web"
            />
          </div>
        </div>
      </div>
    </section>

    <!-- 4. CTA Section -->
    <!-- <section class="cta-section">
      <div class="container">
        <div class="cta-box">
          <div class="cta-image">
            <img
              src="../../static/images/publisher/cta-illustration.png"
              alt="Sign up as an Advertiser"
            />
          </div>
          <div class="cta-text">
            <h2>Sign up as an Advertiser Now</h2>
            <p>
              Unlock a new leads increasing channel by connecting us. Benefit
              from our organized, transparent partnership model.
            </p>
            <button class="btn btn-cta" @click="openContactForm">
              Sign Up now
            </button>
          </div>
        </div>
      </div>
    </section> -->
  </div>
</template>

<script>
export default {
  name: "LeadGenPage",
  methods: {
    openContactForm() {
      // 触发在 App.vue 中定义的事件，打开表单
      this.$emit("open-form");
    },
    openLoginForm() {
      this.$emit("open-login-modal");
    },
  },
};
</script>

<style scoped>
/* General Page Styles */
.advertiser-page {
  font-family: "Poppins", sans-serif; /* 假设使用和 Publisher 页面相同的字体 */
  color: #333;
  background-color: #f0f8ff; /* 一个淡蓝色背景，类似设计图 */
  overflow-x: hidden;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  position: relative;
  z-index: 2;
}

h1,
h2,
h3 {
  font-weight: 700;
  color: #1c2b4e; /* 深蓝色文字 */
}

p {
  line-height: 1.7;
  color: #5a6472; /* 灰色文字 */
}

.btn {
  padding: 14px 35px;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}

.btn:hover {
  transform: translateY(-3px);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);
}

/* 1. Hero Section */
.hero-section {
  font-family: "Poppins", sans-serif;
  color: #333;
  overflow-x: hidden;
  padding-top: 120px; /* 增加顶部间距，让内容远离导航栏 */
  padding-bottom: 100px;

  /* --- 添加这些样式 --- */
  background-image: url("/static/images/publisher/hero-bg.jpg");
  background-size: cover;
  background-position: top center;
  background-repeat: no-repeat;
  /* 可选：添加这个属性可以让背景在滚动时固定，有视差效果 */
  background-attachment: fixed;
  /* 设置一个基础背景色，以防图片加载失败 */
  background-color: #f0f7ff;
}

.hero-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 40px;
}

.hero-text {
  flex-basis: 50%;
}

.hero-text h1 {
  font-size: 42px; /* 根据设计图调整字体大小 */
  margin-bottom: 20px;
  line-height: 1.3;
}

.hero-text p {
  font-size: 16px;
  margin-bottom: 30px;
  max-width: 500px;
}

.hero-buttons {
  display: flex;
  gap: 20px;
}

.btn-primary {
  background: linear-gradient(90deg, #4b89ff, #296dff);
  color: white;
}

.btn-secondary {
  background: linear-gradient(90deg, #30d5c8, #20c997);
  color: white;
}

.hero-image {
  flex-basis: 50%;
  text-align: right;
}

.hero-image img {
  max-width: 100%;
  height: auto;
}

/* 2. Why Section */
.why-section {
  padding: 100px 0;
  background-color: #fff;
}

.why-container {
  display: flex;
  align-items: center;
  gap: 60px;
}

.why-image {
  flex-basis: 45%;
}

.why-image img {
  max-width: 100%;
}

.why-text {
  flex-basis: 55%;
}

.why-text h2 {
  font-size: 40px;
  margin-bottom: 20px;
}

.why-text p {
  font-size: 16px;
}

.why-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.why-list li {
  font-size: 16px;
  line-height: 1.8;
  color: #555;
  margin-bottom: 12px;
  position: relative;
  padding-left: 20px;
}

.why-list li::before {
  content: "•";
  color: #1c2b4e;
  font-size: 1.2em;
  position: absolute;
  left: 0;
  top: 0;
  font-weight: bold;
}

.why-list li:last-child {
  margin-bottom: 0;
}

/* 3. Features Section */
.features-section {
  padding: 100px 0;
  text-align: center;
  background-color: #f0f8ff; /* 淡蓝色背景 */
}

.features-section h2 {
  font-size: 40px;
  margin-bottom: 60px;
}

.features-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 40px;
  text-align: left;
}

.feature-item {
  background: transparent; /* 设计图中没有白色背景框 */
  padding: 20px;
  border-radius: 12px;
}

.feature-item img {
  height: 60px;
  margin-bottom: 25px;
  display: block; /* 让图片成为一个块级元素 */
  margin-left: auto; /* 自动计算左外边距 */
  margin-right: auto;
}

.feature-item h3 {
  font-size: 20px;
  margin-bottom: 15px;
}

.feature-item p {
  font-size: 15px;
}

.feature-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.feature-list li {
  font-size: 15px;
  line-height: 1.8;
  color: #5a6472;
  margin-bottom: 10px;
  position: relative;
  padding-left: 20px;
}

.feature-list li::before {
  content: "•";
  color: #1c2b4e;
  font-size: 1.2em;
  position: absolute;
  left: 0;
  top: 0;
  font-weight: bold;
}

.feature-list li:last-child {
  margin-bottom: 0;
}

/* Partners Section */
.partners-section {
  padding: 120px 0;
  background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 50%, #f0f7ff 100%);
  text-align: center;
  position: relative;
  overflow: hidden;
}

.partners-section::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: radial-gradient(
      circle at 20% 30%,
      rgba(75, 137, 255, 0.03) 0%,
      transparent 50%
    ),
    radial-gradient(
      circle at 80% 70%,
      rgba(45, 109, 255, 0.03) 0%,
      transparent 50%
    );
  pointer-events: none;
}

.partners-section h2 {
  font-size: 42px;
  color: #1c2b4e;
  margin-bottom: 70px;
  font-weight: 700;
  position: relative;
  z-index: 1;
  letter-spacing: -0.5px;
}

.partners-section h2::after {
  content: "";
  display: block;
  width: 80px;
  height: 4px;
  background: linear-gradient(90deg, #4b89ff, #296dff);
  margin: 20px auto 0;
  border-radius: 2px;
}

.partners-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 35px;
  max-width: 1100px;
  margin: 0 auto;
  justify-items: center;
  position: relative;
  z-index: 1;
}

.partner-logo {
  background-color: #ffffff;
  border: 1.5px solid #e0e0e0;
  border-radius: 16px;
  padding: 30px 35px;
  width: 100%;
  max-width: 300px;
  height: 150px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  box-sizing: border-box;
  position: relative;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04), 0 1px 3px rgba(0, 0, 0, 0.06);
}

.partner-logo::before {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(75, 137, 255, 0.05),
    transparent
  );
  transition: left 0.5s ease;
}

.partner-logo:hover::before {
  left: 100%;
}

.partner-logo:hover {
  transform: translateY(-8px) scale(1.02);
  border-color: #4b89ff;
  box-shadow: 0 12px 30px rgba(75, 137, 255, 0.15),
    0 4px 12px rgba(0, 0, 0, 0.1);
  background-color: #fafbff;
}

.partner-logo img {
  max-width: 100%;
  max-height: 100%;
  width: auto;
  height: auto;
  object-fit: contain;
  transition: transform 0.3s ease;
  filter: grayscale(20%);
}

.partner-logo:hover img {
  transform: scale(1.05);
  filter: grayscale(0%);
}

/* 4. CTA Section */
.cta-section {
  padding: 120px 0;
  background-image: url("/static/images/publisher/xbj.png");
  background-size: contain; /* 让背景图铺满整个区域 */
  background-position: center; /* 背景图居中显示 */
  background-repeat: no-repeat; /* 背景图不重复 */
}

.cta-box {
  background: #fff;
  border-radius: 20px;
  box-shadow: 0 10px 40px rgba(75, 137, 255, 0.15); /* 蓝色调阴影 */
  display: flex;
  align-items: center;
  padding: 60px;
  gap: 50px;
  overflow: hidden;
}

.cta-image {
  flex-basis: 45%;
}

.cta-image img {
  max-width: 100%;
}

.cta-text {
  flex-basis: 55%;
}

.cta-text h2 {
  font-size: 36px;
  line-height: 1.3;
  margin-bottom: 15px;
}

.cta-text p {
  font-size: 18px;
  margin-bottom: 30px;
}

.btn-cta {
  background: linear-gradient(90deg, #4b89ff, #296dff);
  color: white;
  font-size: 18px;
  padding: 18px 50px;
  border-radius: 10px;
}

/* Responsive Design */
@media (max-width: 992px) {
  .hero-container,
  .why-container {
    flex-direction: column;
    text-align: center;
  }

  .hero-text,
  .why-text {
    order: 2;
  }

  .hero-image,
  .why-image {
    order: 1;
    margin-bottom: 40px;
    text-align: center;
  }

  .hero-text h1 {
    font-size: 38px;
  }
  .why-text h2,
  .features-section h2,
  .partners-section h2 {
    font-size: 32px;
  }
  .hero-buttons {
    justify-content: center;
  }

  .partners-section {
    padding: 80px 15px;
  }

  .partners-section h2 {
    font-size: 32px;
    margin-bottom: 50px;
  }

  .partners-section h2::after {
    width: 60px;
    height: 3px;
    margin: 15px auto 0;
  }

  .partners-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 25px;
    max-width: 600px;
  }

  .partner-logo {
    max-width: 100%;
    height: 130px;
    padding: 25px 30px;
    border-radius: 14px;
  }

  .cta-box {
    flex-direction: column;
    text-align: center;
    padding: 40px 30px;
  }
  .features-grid {
    text-align: center;
  }
}

@media (max-width: 480px) {
  .partners-section {
    padding: 60px 15px;
  }

  .partners-section h2 {
    font-size: 26px;
    margin-bottom: 40px;
  }

  .partners-section h2::after {
    width: 50px;
    height: 3px;
    margin: 12px auto 0;
  }

  .partners-grid {
    grid-template-columns: 1fr;
    gap: 20px;
    max-width: 100%;
  }

  .partner-logo {
    max-width: 100%;
    height: 120px;
    padding: 20px 25px;
    border-radius: 12px;
  }

  .partner-logo:hover {
    transform: translateY(-5px) scale(1.01);
  }
}
</style>
